import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'

import { useCanViewReadOnly } from '../../useCanConfigureApplications'

const useStyles = makeStyles(() => ({
  alertContainer: {
    paddingBottom: '30px',
    margin: '0 auto',
  },
}))

const RoleBanner = () => {
  const classes = useStyles()
  return (
    <Box className={classes.alertContainer}>
      <Alert
        severity="info"
        data-testid="alert"
      >
        <strong>Read-Only View:</strong> You currently don&apos;t have the permissions to update this page. If you would
        like access, please contact the Account Administrator at your institution and request the Application Manager
        role.
      </Alert>
    </Box>
  )
}

const AppManagerRoleBanner = () => {
  const canViewReadOnly = useCanViewReadOnly()
  return canViewReadOnly ? <RoleBanner /> : null
}

export default AppManagerRoleBanner
